// v1.0.0 · El backend ahora exige sesión en los módulos internos.
//   · Toda petición de axios a nuestro backend lleva «Authorization: Bearer <token>» si hay sesión y la página
//     no envió ya su propio header.
//   · Si el backend responde 401 estando en un portal interno (sesión vencida o inválida), se limpia la sesión
//     y se vuelve a /login. Las páginas públicas (landing, pagos, firma por enlace) no redirigen.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const PRIVATE_PREFIXES = ["/finanzas", "/contratos", "/customer", "/mercado", "/usuarios", "/qa",
  "/configuracion", "/compras", "/contabilidad", "/auditoria"];   // v1.22.0 · auditoría
const PUBLIC_PREFIXES = ["/qa/firmar-acta"];

function isOurBackend(url) {
  if (!url) return false;
  if (url.startsWith("/api")) return true;
  return !!BACKEND_URL && url.startsWith(BACKEND_URL);
}

function isPrivatePage(pathname) {
  if (PUBLIC_PREFIXES.some((p) => pathname.startsWith(p))) return false;
  return PRIVATE_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));
}

axios.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("token");
    if (token && isOurBackend(config.url)) {
      config.headers = config.headers || {};
      const has = typeof config.headers.has === "function"
        ? config.headers.has("Authorization")
        : !!(config.headers.Authorization || config.headers.authorization);
      if (!has) {
        if (typeof config.headers.set === "function") config.headers.set("Authorization", `Bearer ${token}`);
        else config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } catch (_) { /* sin localStorage: se envía sin sesión */ }
  return config;
});

let redirecting = false;
axios.interceptors.response.use(
  (r) => r,
  (error) => {
    try {
      const status = error?.response?.status;
      const url = error?.config?.url || "";
      if (status === 401 && isOurBackend(url) && !url.includes("/auth/login")
          && isPrivatePage(window.location.pathname) && !redirecting) {
        redirecting = true;
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.assign("/login");
      }
    } catch (_) { /* nada */ }
    return Promise.reject(error);
  }
);
